<div class="card" style="margin-top: 40px;">
    <div class="card-header">Tjäldjupstationer ordnade från norr till söder. Klicka på en station för att markera och panorera dit.</div>
    <div class="card-body">
      <div class="container-fluid" style="overflow-y: auto;" id="stationlist">
        <ul>        
            <app-stationlist-item  *ngFor="let station of frostmeasurementstations"
            [station]="station">           
           
        </app-stationlist-item>  
        </ul>
           
      </div>
    </div>   
  </div>
